import React, { useState } from "react";
import * as S from "./styles";

import ArrowUp from "../../../../src/assets/images/arrow_up_orange.svg.svg";

export default function PlansMobile({
  content,
  planos,
  planIndex = 0,
  planOpenIndex = null,
  planOptionIndex = 0,
  title = "Planos UOL Play disponíveis",
  hiddenSubtitle = false,
  hiddenReceba40 = false,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [openIndex, setOpenIndex] = useState(planOpenIndex);
  const [optionIndex, setOptionIndex] = useState(planOptionIndex);
  const [imageIndex, setImageIndex] = useState(0);

  function escanor(index) {
    setOpenModal(true)
    setImageIndex(index)
  }

  function scrollToElementById(id, offset = 80) {
    const element = document.getElementById(id);

    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const position = elementPosition - offset;

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });
    }
  }

  function handleScrollAndOpen(id, index) {
    setTimeout(() => {
      scrollToElementById(id);
    }, 300);
    setOpenIndex(index);
  }

  return (
    <S.Section>
      <S.ModalOverlay openModal={openModal} onClick={() => setOpenModal(false)}>
        <S.Modal>
          <S.ModalClose onClick={() => setOpenModal(false)}>X</S.ModalClose>
          <img src={planos[imageIndex]?.logosMobile} alt="parceiros uol" />
        </S.Modal>
      </S.ModalOverlay>

      <S.Title>{title}</S.Title>
      <S.SubTitleDiv>
        {!hiddenSubtitle && (
          <S.SubTitle>
            <span>
              <strong>Ganhe R$ 40 todo mês</strong> em cinema na
            </span>
            <span>
              <S.ImgIngresso
                src="https://imguol.com.br/p/pp/uol-play/nova-pv/planos/logo_ingresso.svg"
                alt="Logo Ingresso.com"
              />
              nos planos anuais
            </span>
          </S.SubTitle>
        )}
        <S.BenefitsDiv>
          Todos incluem:
          <S.Benefits>
            {content?.map((content) => (
              <S.Benefit key={content.id}>
                <S.ImgBenefit src={content.imgSrc} alt={content.alt} />
                <S.TextBenefit>{content.text}</S.TextBenefit>
              </S.Benefit>
            ))}
          </S.Benefits>
        </S.BenefitsDiv>
      </S.SubTitleDiv>

      <S.AccordionContainer id="planos-mobile">
        {planos?.map((plano, index) => (
          <S.Accordion
            isOpen={openIndex === index}
            key={"accordion-plans" + index}
            id={plano.id}
          >
            <div className="accordion-header">
              <S.AccordionTitle>{plano.name}</S.AccordionTitle>
              {openIndex === index ? (
                <img
                  src={ArrowUp}
                  alt="ArrowUp"
                  onClick={() => setOpenIndex(null)}
                />
              ) : (
                <S.PriceHeaderPlans>
                  <p>A partir de</p>
                  <p>
                    R$ <strong>{plano.startingPrice}</strong>/mês
                  </p>
                </S.PriceHeaderPlans>
              )}
            </div>
            <S.ChannelsImgContainer
              onClick={() => escanor(index)}
              isOpen={openIndex === index}
            >
              <img src={plano.logosMobileHeader} alt={plano.id} />
            </S.ChannelsImgContainer>
            <S.PlansDescription>{plano.description}</S.PlansDescription>
            <S.PlannContainer>
              {plano.options.map((option, index) => (
                <>
                  {option.id === "monthly" ? (
                    <S.MonthlyPlan
                      checked={optionIndex === index}
                      onClick={() => setOptionIndex(index)}
                    >
                      <S.RadioContainer>
                        <S.HiddenRadio
                          type="radio"
                          value="monthly"
                          checked={optionIndex === index}
                        />
                        <S.CustomRadio />
                        <S.PriceRadioLabel checked={optionIndex === index}>
                          {option.name}
                        </S.PriceRadioLabel>
                      </S.RadioContainer>
                      <S.PriceMonthly checked={optionIndex === index}>
                        R$ <strong>{option.price}</strong>
                        {option.suffixOption}
                      </S.PriceMonthly>
                    </S.MonthlyPlan>
                  ) : (
                    <S.AnnualPlan
                      checked={optionIndex === index}
                      onClick={() => setOptionIndex(index)}
                    >
                      <S.Discount checked={optionIndex === index}>
                        <p>{option.discount}% de desconto</p>
                      </S.Discount>
                      <S.RadioContainer>
                        <S.HiddenRadio
                          type="radio"
                          value="annual"
                          checked={optionIndex === index}
                        />
                        <S.CustomRadio />
                        <S.PriceRadioLabel checked={optionIndex === index}>
                          {option.name}
                        </S.PriceRadioLabel>
                      </S.RadioContainer>
                      <S.AnnualPrice
                        hiddenReceba40={hiddenReceba40}
                        checked={optionIndex === index}
                      >
                        <p>
                          {option.installments} R${" "}
                          <strong>{option.price}</strong>
                        </p>
                        <small>
                          Total R$ {option.totalPrice}
                          {option.suffixOption}
                        </small>
                      </S.AnnualPrice>
                      {!hiddenReceba40 && (
                        <S.CinemaOffer checked={optionIndex === index}>
                          <p>
                            <strong>Ganhe R$ 40</strong> <br /> na ingresso.com
                          </p>
                        </S.CinemaOffer>
                      )}
                    </S.AnnualPlan>
                  )}
                </>
              ))}

              {openIndex === index ? (
                <S.CtaLink
                  isOpen={openIndex === index}
                  href={planos[index]?.options[optionIndex]?.ctaUrlMobile}
                >
                  {planos[index]?.options[optionIndex]?.ctaText}
                </S.CtaLink>
              ) : (
                <S.CtaButton
                  onClick={() => handleScrollAndOpen(plano.id, index)}
                  isOpen={openIndex === index}
                >
                  {planos[index]?.options[optionIndex]?.ctaText}
                </S.CtaButton>
              )}
            </S.PlannContainer>
          </S.Accordion>
        ))}
      </S.AccordionContainer>
    </S.Section>
  );
}
